export default {
  login: {
    title: 'Log In',
    subheading: "Don't have an account?",
    buttonText: 'Log In',
    errorMessages: {
      default: 'Your email or password do not match. {br}Please try again.',
      session_expired: 'You were inactive for a while so your session has expired. Please log in again.',
    },
  },
  storeLogin: {
    title: 'Complete your order',
    subheading:
      "It's more than just a tag or tracker; it's your pet's ticket home. To maximize the benefits of our Home<em>Safe</em><sup>&reg;</sup> lost pet service, we need some essential information about you and your pet. Log In or Sign Up to complete your order.",
    buttonTextSignUp: 'Sign Up',
    buttonTextLogIn: 'Log In',
    or: 'OR',
    lowerHeader: "It's more than just a tag or tracker!",
  },
  forgotPassword: {
    title: 'Forgot your password?',
    info: "No problem! We'll email you a link to reset your password so you can log into your account.",
    buttonText: 'Reset Password',
    onSuccess: {
      title: 'Almost Done!',
      info: "If you have an account, we'll send an email with instructions to reset your password.",
    },
  },
  resetPassword: {
    title: 'Reset Your Password',
    subheading: 'Almost done, create a new password below.',
    buttonText: 'Reset Password',
    password: {
      title: 'New Password',
    },
    passwordConfirm: {
      placeholder: 'Re-Enter password',
      title: 'Confirm New Password',
    },
    onSuccess: {
      title: 'Success!',
      infoText: 'Your password has been updated.',
      buttonText: 'Return to Log In',
    },
    errorMessages: {
      default: 'There was a problem with password reset.{br}Please try again.',
      currentPassword: 'New password cannot be same as current password',
      mismatch: 'Password confirmation does not match',
    },
  },
  completeActivation: {
    loading: {
      title: 'Fetching your Record',
      subheading: "You'll be able to create your online account very shortly",
    },
    title: 'Hi {firstName}!',
    subheading: 'Your secure online account can be used to…',
    subheadingList: [
      'License any pets',
      'Update the ownership status of any pets',
      'Update your current address and contact information',
      'And so much more!',
    ],
    nonLicensing: {
      title: "You're almost done.",
      subheading: 'Set your password and jump into a world built to keep {petName} protected, and give you peace of mind.',
      petFallback: 'your pet',
    },
    legalText: {
      prepend: "By signing up, you agree to DocuPet's",
      links: {
        termsOfService: 'Terms of Service',
        conjunction: 'and',
        privacyPolicy: 'Privacy Policy',
      },
    },
    buttonText: 'Complete Sign Up',
    errorMessages: {
      access_code_used: "Looks like you've already signed up! {br} {action}",
      default: 'There was a problem with your complete sign-up.{br}Please try again.',
      action: {
        access_code_used: 'Click here to Log In',
      },
      contactCustomerCare:'contactCustomerCare',
    },
    nasn: {
      title: 'Welcome to the family, {petNames}!',
      subheadingSingular:
        "Set a password to get {petNames}'s free tag and access to 24/7 lost pet help. It only takes a moment to protect your new best friend.",
      subheadingPlural:
        'Set a password to get your pets free tag and access to 24/7 lost pet help. It only takes a moment to protect your new best friends.',
      finishTheDetails: 'Finish the Details',
      helpGetLostPetsHome: 'Help Get Lost Pets Home',
      stayInformed: 'Stay Informed',
      buttonText: 'Get Your Free Tag',
    },
  },
  fetchMyRecord: {
    title: 'Access my license record',
    subheading:
      'If you’ve licensed a pet with {getCityOrganization} before, we likely have your record on file — let’s look it up! If you’ve never licensed your pet with {getCityOrganization} before {action}.',
    buttonText: {
      primary: 'Search',
    },
    actionText: {
      signUpHere: "Sign up here"
    },
    nonLicensing: {
      title: "Let's get your pet protected!",
      subheading: 'Your access code opens the door to complete identification, protection, and care.',
    },
    byAccessCode: {
      linkText: 'See an example',
      descriptionLineOne: 'of an "Access Code"',
      descriptionLineTwo: 'we sent you by mail or email?',
      title: 'I received an access code via mail, phone, or email',
      subheading: 'I have an access code from a letter or email',
      buttonText: {
        secondary: "I will use my pet's tag number",
      },
      modal: {
        accessCodeExample:{
          title:'Access Code Example',
        },
        accessCode: {
          title: "What is an Access Code?",
          content:
            "When we get records from the {getCityOrganization} we send license renewal reminder with Access Codes via mail and email (if an email address has been provided). These unique codes can be used only if the contact information provided matches that of the original record. Once your access code has been used to successfully make a match with your account, you will proceed with creating credentials for your online account where you will find all details pertaining to your pet's license. ",
        },
      },
      errorMessages: {
        invalid_access_code:
          'Incorrect Access code or Zip code. Please check your email or letter to confirm the correct information.',
        access_code_used: "Looks like you've already signed up! {br} {action}",
        default: 'There was problem fetching your record. Please try again.',
        action: {
          access_code_used: 'Click here to Log In',
        },
        onlyAlphaNumericCharacters: 'The {field} can only contain alpha-numeric characters',
        not_found:"Hmm... we can't find a record that matches these entries. Please ensure that you have entered the information correctly."
      },
      footerMessage:{
        fallbackText:"If this isn't working, you may",
        fallbackLinkText:"try using your pet's current license tag number to access your record",
        learnMoreText: "Learn more about how we source existing records",
      }
    },
    byTagNumber: {
      petTagImgAlt: "HomeSafe Pet Tag ID containing the address and phone number to report the pet as well as the ID number of the pet",
      title: 'Enter my pet’s tag number instead',
      subheading: "I have my pet's tag number",
      buttonText: {
        secondary: 'I will use my access code',
      },
      errorMessages: {
        invalid_tag_number:
          'Incorrect Tag number or Pet Name or Zip code or Phone number. Please check your email or letter to confirm the correct information.',
        access_code_used: "Looks like you've already signed up! {br} {action}",
        default: 'There was problem fetching your record. Please try again.',
        action: {
          access_code_used: 'Click here to Log In',
        },
        not_found: "We are unable to find an exact match for these entries within our records. Please ensure that you have entered the information correctly, and consider trying alternate phone numbers."
      },
      modal: {
        infoTitle: "What is my pet's current license tag number?",
        modalDescription: "We typically have previous licensing records that include pet license tag numbers. If your pet is wearing a tag, use the number found on it here. If this information along with the pet's name, your ZIP code and your phone number match one of your records, we can match your record! You can then create a DocuPet account and you will see your license information in your online profile.",
      },
      footerMessage: {
        fallbackIntro: "If you have received an Access Code",
        fallbackDescription:
          "from us, you can enter it here. Or if you think that {cityOrganization} would have an email address associated with your previous license record, you can request an Access Code.",
        learnMoreText: "Learn more about how we source existing records",
      },
      support: {
        customerCarePrefix:
          "If these options don't work for you, we're sorry for the inconvenience."
      }
    },
  },
  requestAccessCode: {
    title: 'Request Access Code',
    subheading: 'We may be able to email a new access code to you. Enter your Email Address below.',
    buttonText: 'Continue',
    onSuccess: {
      title: 'Almost Done!',
      infoText:
        "We've sent an access code to {email} with instructions to access your account. If the email doesn't arrive soon, please check your spam folder",
      buttonText: 'Return to Fetch My Record',
    },
    errorMessages: {
      invalid_email:
        "We can't find this email address in our system. Please check to see that you're entering the correct email address.",
      access_code_used: "Looks like you've already signed up! {action}",
      default: 'There was problem sending an email. Please try again.',
      action: {
        access_code_used: 'Click here to Log In',
      },
    },
    footerMessage: {
      errorDescription: "We can't find that email address in our records. This information has likely not been provided to us previously. Please ensure that you have entered the information correctly.",
      fallbackIntro: "You may",
      fallbackStrong: "try using your pet's current license tag number",
      fallbackDescription: "to access your record",
      learnMoreText: "Learn more about how we source existing records",
      successMessage: "We have sent you an email with your access code. You can now fetch your record using your access code.",
    },
    validation: {
      emailNotFound: "We can't find that email address in our records."
    },
    modal: {
      title: "How we fetch your existing license records",
      sectionWhyTitle: "Why matching existing records is important",
      sectionWhyDescription:
        "{cityOrganization} has provided us with existing pet licensing records so that we can send reminder notices and keep your information current. It is really important that existing records are updated so that we don't have duplicate information and send unnecessary reminders to you!",

      sectionAccessCodeTitle: "About DocuPet's \"Access Codes\"?",
      sectionAccessCodeDescription:
        "When we send renewal reminders via mail or email (when we have this on file) to pet owners who have not yet created accounts with DocuPet, we include an Access Code. These unique codes ensure that only the contact information on file can access each record.",

      sectionMatchingTitle: "Matching Pet and Pet Owner Data",
      sectionMatchingDescription:
        "Sometimes pet owners who have previously licensed with {cityOrganization} come to our site to renew a pet license without having yet received an Access Code. In these cases, we can often source a previous record using data matching. We will ask for a current license tag number, a pet's name, your ZIP code, and your phone number. If all of these match, we can fetch your record.",

      sectionAccountTitle: "Creating a DocuPet Account",
      sectionAccountDescription:
        "Once we have your record matched, we will send you to the account creation page. Once you have entered your email address and created a password, you will find your existing pet licensing information in your online profile."
    },
    successButtonText: "Fetch my Record by Access Code",
  },
  // HomeSafe
  HomeSafe: '{HomeSafe}',
  homeSafe: {
    content: [
      'The unique code on this tag serves as an identifier to help get your pet home quickly if they become lost',
      'Proactively send lost pet alerts from your account',
      'Automatically receive an alert if your pet is found',
    ],
  },
  // Info
  onlineAccount: {
    heading: 'Your online DocuPet account includes:',
    content: [
      'Hundreds of designer tag styles, or the option to design your very own',
      'Free access to the {HomeSafe} 24/7 lost pet service',
      "A central dashboard for your pet's information and records",
    ],
  },
  text: {
    light: {
      WelcomeTo: 'Welcome to',
    },
    bold: {
      DocuPet: 'DocuPet',
    },
    brand: {
      home_safe: "Home<span class=\"font-italic\">Safe<sup>&reg;</sup></span>"
    },
  },
  input: {
    email: {
      label: 'Email Address',
      placeholder: 'Enter email address',
    },
    password: {
      label: 'Password',
      placeholder: 'Enter your password',
      buttonText: {
        show: 'Show',
        hide: 'Hide',
      },
    },
    createPassword: {
      label: 'Create a password',
      placeholder: 'Create a password',
    },
    newPassword: {
      label: 'New Password',
      placeholder: 'Create new password',
    },
    passwordConfirm: {
      label: 'Confirm New Password',
      placeholder: 'Re-enter new password',
    },
    accessCode: {
      label: 'Enter my 8 or 9 digit access code',
      placeholder: 'Enter access code (e.g. FAB12345)',
      errorMessages: 'The access code is required',
      onlyAlphaNumericCharacters: 'The access code can only contain alpha-numeric characters'
    },
    postalCode: {
      label: 'Zip Code Associated with Record',
      placeholder: 'Enter Zip code',
      errorMessages: 'Please enter your ZIP code',
    },
    tagNumber: {
      label: 'Tag Number',
      placeholder: 'Enter tag number (e.g. A1B27890)',
      aboveLabel:
        'The tag number and two of the three following fields must match to be able access your license record.',
      errorMessages: {
        tag_number_required: 'Please enter exactly as seen on tag.',
      },
    },
    petName: {
      label: 'Pet Name',
      placeholder: 'Enter pet name',
      errorMessages: 'Please enter your pet name'
    },
    phoneNumber: {
      label: 'Phone Number Associated with Record',
      placeholder: 'Enter phone number',
      customErrorMessage: 'Please enter your ten digit phone number',
    },
  },
  checkbox: {
    eula: 'I agree',
    petalert: 'I would like to receive alerts about pets lost near my residence.',
    shelter: 'I would like to share my profile with the National Animal Shelter network so they can reunite me with my pets if they become lost.',
  },
  link: {
    accessCode: {
      dontHave: "Don't have an access code?",
    },
    signUp: 'Sign Up',
    forgotPassword: 'Forgot your password?',
    login: {
      return: 'Return to Log In',
    },
    fetchMyRecord: {
      return: 'Return to Fetch My Record',
    },
  },
  validations: {
    messages: {
      required: 'req',
    },
  },
  footer: {
    copyright: 'DocuPet Corp. All rights reserved.',
    links: {
      about: 'About DocuPet',
      tos: 'Terms of Service',
      privacy: 'Privacy Policy',
    },
  },
  meta: {
    title: {
      LogIn: 'Log In',
      ResetPassword: 'Reset your password',
      ForgotPassword: 'Forgot your password?',
      CompleteSignup: 'Complete your sign-up',
      RequestAccessCode: 'Request access code',
      FetchMyRecordByPetTag: 'Fetch my record',
      FetchMyRecordByAccessCode: 'Fetch my record',
      FetchMyRecordByTagNumber: 'Fetch my record',
      StoreLogIn: 'Store Log In',
    },
  },
  CUSTOMER_CARE_PHONE: '1-877-239-6072',
};
